export default function Logo({ size = 40, testid = "brand-logo" }) {
    return (
        <img
            data-testid={testid}
            src="/logo-ebh1.webp"
            alt="Logo Exército Brasileiro — EQUIPE STAFF [EBH1]"
            width={size}
            height={size}
            className="rounded-lg object-cover ring-1 ring-white/15"
            style={{ width: size, height: size }}
        />
    );
}
